import '../../../common/dashboard/filters/unapplied/toggleable_unapplied_filter_view.js.coffee'
import '../../../common/dashboard/filters/fixed_string_filter_mixin.js.coffee'
import '../single_filters/fixed_string_filter_view.js.coffee'

Namespace 'CustomerVisualMode.Filters.Unapplied'

class CustomerVisualMode.Filters.Unapplied.UnappliedHierarchicalTagsFilterView extends
Common.Dashboard.Filters.ToggleableUnappliedFilterView

  initialize: ({filter}) ->
    super({filter})
    _.extend(@, CustomerVisualMode.Filters.HierarchicalTagsFilterMixin)

  _displayTitle: ->
    @filter.getName()

  toggleOpenFilter: ->
    @openHierarchicalTagsFilterModal()

  modalTitle: ->
    @filter.getName()
